import { render } from "./GenericPopup.vue?vue&type=template&id=2545495c&scoped=true"
import script from "./GenericPopup.vue?vue&type=script&lang=js"
export * from "./GenericPopup.vue?vue&type=script&lang=js"

import "./GenericPopup.vue?vue&type=style&index=0&id=2545495c&lang=scss"
import "./GenericPopup.vue?vue&type=style&index=1&id=2545495c&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2FGenericPopup.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2545495c"]])

export default __exports__